var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12137_66062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 15H8.08125L8.04688 15.1406C7.975 15.4281 7.99062 15.7281 8.0875 16H2C0.896875 16 0 15.1031 0 14V2C0 0.896875 0.896875 0 2 0H6.87813C7.275 0 7.65625 0.159375 7.9375 0.440625L11.5594 4.05937C11.8406 4.34062 12 4.72188 12 5.11875V8.925L11 9.925V6H7.5C6.67188 6 6 5.32812 6 4.5V1H2C1.44687 1 1 1.44687 1 2V14C1 14.5531 1.44687 15 2 15ZM10.9844 5C10.9625 4.9125 10.9187 4.83125 10.8531 4.76875L7.23125 1.14688C7.16562 1.08125 7.0875 1.0375 7 1.01562V4.5C7 4.775 7.225 5 7.5 5H10.9844ZM16.2031 8.25C16.0094 8.05625 15.6906 8.05625 15.4969 8.25L14.7219 9.025L15.9688 10.2719L16.7437 9.49687C16.9375 9.30312 16.9375 8.98438 16.7437 8.79062L16.2062 8.25H16.2031ZM10.7 13.0469C10.6344 13.1125 10.5906 13.1906 10.5688 13.2781L10.1875 14.8094L11.7156 14.4281C11.8031 14.4062 11.8844 14.3594 11.9469 14.2969L15.2656 10.9781L14.0188 9.73125L10.7 13.0469ZM14.7906 7.54375C15.375 6.95937 16.325 6.95937 16.9125 7.54375L17.4531 8.08438C18.0375 8.66875 18.0375 9.61875 17.4531 10.2063L12.6562 15.0031C12.4625 15.1969 12.2219 15.3313 11.9594 15.3969L9.62187 15.9812C9.45 16.025 9.27188 15.975 9.14688 15.85C9.02188 15.725 8.97188 15.5469 9.01562 15.375L9.6 13.0375C9.66563 12.775 9.80312 12.5312 9.99375 12.3406L14.7906 7.54375Z",
    fill: "#1D1F2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12137_66062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePen);
export default __webpack_public_path__ + "static/media/file-pen.c5fbebcb9537d7fd257704241d726c22.svg";
export { ForwardRef as ReactComponent };